import { Component, input, type InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe],
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
})
export class PageHeaderComponent {
    public readonly icon: InputSignal<string> = input.required<string>();

    public readonly title: InputSignal<string> = input.required<string>();

    public readonly subtitle: InputSignal<string | undefined> = input<string>();
}
